// GENERATED FILE — do not edit by hand.
// Written by scripts/generate-version.mjs on every build (npm prebuild + deploy).
// Format: v<appVersion>-A<angularMajor>[+<gitSha|timestamp>]
export const APP_VERSION = 'v0.1.0-A20';
export const APP_VERSION_FULL = 'v0.1.0-A20+7762475';
export const APP_BUILD_ID = '7762475';
export const APP_RELEASE_DATE = '2026-11-03T22:59:44.130Z';
export const ANGULAR_MAJOR = 20;
